export default __webpack_public_path__ + "static/s1-a1896fca46f76a32508432504790b46e.webp";